'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var styled = require('styled-components');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var Typography = require('../../../../common/components/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);

const ItemImagesContainer = styled__default["default"].div.withConfig({
  componentId: "sc-xm0nmf-0"
})(["display:flex;flex-direction:row;gap:0.25rem;align-items:center;"]);
const ItemImagesList = styled__default["default"].ul.withConfig({
  componentId: "sc-xm0nmf-1"
})(["display:flex;flex-direction:row;gap:0.25rem;align-items:center;margin:0;padding:0;list-style:none;"]);
const ClaimsListItem = _ref => {
  let {
    claimItems,
    listLabelId
  } = _ref;
  const {
    claimsClaimDetailsItemsCount
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(ItemImagesContainer, null, /*#__PURE__*/React__default["default"].createElement(ItemImagesList, {
    "aria-labelledby": listLabelId
  }, claimItems === null || claimItems === void 0 ? void 0 : claimItems.slice(0, 5).map(item => /*#__PURE__*/React__default["default"].createElement("li", {
    key: item.name
  }, /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
    productInfo: {
      imageUrl: item.itemImage,
      name: item === null || item === void 0 ? void 0 : item.name
    },
    s: {
      width: '2rem'
    }
  })))), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, {
    id: listLabelId,
    secondary: true
  }, mustache__default["default"].render(claimsClaimDetailsItemsCount ?? '', {
    count: claimItems.length
  })));
};
var ClaimsListItemImages = nthHookTranslations.withTranslationsProvider(ClaimsListItem, {
  translationKeys: ['claimsClaimDetailsItemsCount']
});

exports["default"] = ClaimsListItemImages;
